import { render, staticRenderFns } from "./ContactTypesTags.vue?vue&type=template&id=eb4729be&scoped=true&"
import script from "./ContactTypesTags.vue?vue&type=script&lang=js&"
export * from "./ContactTypesTags.vue?vue&type=script&lang=js&"
import style0 from "./ContactTypesTags.vue?vue&type=style&index=0&id=eb4729be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4729be",
  null
  
)

export default component.exports